<app-national-park
[tripEntries]="tripEntries"
[mapLat]="mapLat"
[mapLng]="mapLng"
[animalEntries]="animalEntries"
[galleries]="[footprintGallery, plainsGallery, rockGallery]"
[parkBoundaries]="parkBoundaries"
[zoom]="zoom"
parkId="Olduvai Gorge"
[paragraphs]="parkText.paragraphs"
[paragraphHeaders]="parkText.paragraphHeaders"
bannerImage="../../../../../assets/img/1920x800/hawk-olduvai.jpg"
[largeImgHeightAndBackgroundPosition]="['300px', 'bottom left']"
[medImgHeightAndBackgroundPosition]="['275px', 'bottom left']"
[smallImgHeightAndBackgroundPosition]="['200px', '40% 0%']"
[hasBadge]="true"
[mobileCircleWidths]="circleWidthsMobile"
[desktopCircleWidths]="circleWidthsDesktop"
[badgeHtml]="parkText.badge"
[factsHeader]="parkText.factsHeader"
[factSet]="parkText.facts"
mobileTripListHeight="531.59px"
[isOneSpot]="false"
tripListParkName="Olduvai Gorge World Heritage Site"
parkRoute="olduvai-gorge"
>
</app-national-park>
